(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class stickyAtc extends HTMLElement {
    connectedCallback() {
      this.isMobile = window.innerWidth < 769;
      this.visibilityMap = new Map();
      this.closeButton = this.querySelector('.sticky-atc-close');

      this.initTargets();
      if (!this.targets.length) return;

      this.observeTargets();
      // if (this.isMobile) this.bindScrollTrigger();

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }
    }

    close() {
      this.classList.remove('fixed');
      if (this.observer && this.targets) {
        this.targets.forEach(target => this.observer.unobserve(target));
      }
      this.visibilityMap.clear();
    }

    initTargets() {
      const selectors = this.isMobile
        ? ['.product-single__sticky', '.product-buy_button', '.shopify-app-block']
        : ['.product-single__title', '.product-buy_button', '.shopify-app-block'];

      this.targets = selectors
        .map(sel => document.querySelector(sel))
        .filter(Boolean);
    }

    observeTargets() {
      const headerHeight = getComputedStyle(document.documentElement).getPropertyValue("--header-height").trim();
      // const observer = new IntersectionObserver(this.handleIntersect.bind(this));
      const observer = new IntersectionObserver(
        this.handleIntersect.bind(this),
        {
          rootMargin: `-${headerHeight} 0px 0px 0px`,
        }
      );
      this.targets.forEach(target => {
        this.visibilityMap.set(target, true); // assume visible
        observer.observe(target);
      });
    }

    handleIntersect(entries) {
      entries.forEach(entry => {
        this.visibilityMap.set(entry.target, entry.isIntersecting);
      });

      const anyVisible = Array.from(this.visibilityMap.values()).some(Boolean);
      this.classList.toggle('fixed', !anyVisible);
    }

    bindScrollTrigger() {
      const trigger = this.querySelector('.sticky-atc-flex');
      const scrollTarget = document.querySelector('.buy_buttons_flex');

      if (trigger && scrollTarget) {
        trigger.addEventListener('click', () => {
          scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  }
  customElements.define('sticky-atc', stickyAtc);

  } catch(e) { console.error(e); }
})();
})();
